export default __webpack_public_path__ + "static/media/zoom-out.3943712b.svg";